import _debounce from 'lodash.debounce';
import isBreakpoint from '~scripts/utility/media-query';
import waitForElementTransition from 'wait-for-element-transition';
import NavMenuLangSelector from './menu-lang-selector';

/**
 * Dropdown menu controller
 */
const DropdownMenu = {
  _isOpen: false,

  _depth: 0,

  _selectors: {
    headerNav: '.js-header-nav',
    mobDropdown: '.js-nav-mobile-dropdown',
    mobDropdownMenuContainer: '.js-nav-dropdown-menu-container',
    mobDropdownMenu: '.js-nav-dropdown-menu',
    btnOpen: '.js-nav-dropdown-btn-open',
    menuItem: '.js-nav-menu-item.nav-menu-item--has-children',
    subMenu: '.js-nav-submenu',
  },

  init() {
    const self = this;

    // Event :: open / close buttons
    document.querySelector(this._selectors.btnOpen).addEventListener('click', this.toggleShowAndHide.bind(this));

    // Event :: close menu when clicking outside it
    document.querySelector('body').addEventListener('click', this.handleOutsideClick);

    // Event :: close sidebar when viewport changes
    window.addEventListener('resize', _debounce(() => {
      self.handleDropdownVisibility();
    }, 200));

    // Event :: clicking on items with children, reveals the submenu
    const dropdownMenu = document.querySelector(this._selectors.mobDropdownMenu);
    const menuItems = dropdownMenu.querySelectorAll(this._selectors.menuItem);
    for (let i = 0; i < menuItems.length; i++) {
      menuItems[i].addEventListener('click', function() {
        self.handleMenuItemClick(i); // Pass the index directly to the handler
      });
    }
    
    // Initialises LangSelector
    NavMenuLangSelector.init();
  },

  toggleShowAndHide() {
    const self = this;
  
    // Toggle the 'no-scroll' class on the body element
    document.querySelector('body').classList.toggle('no-scroll');
  
    // Check the current state of _isOpen and toggle the dropdown accordingly
    const dropdown = document.querySelector(this._selectors.mobDropdownMenuContainer);
    const btnToggle = document.querySelector(this._selectors.btnOpen);

    if (self._isOpen) {
      dropdown.classList.remove('show');
      btnToggle.classList.remove('opened');

      self._isOpen = false; // Update the state
    } else {
      dropdown.classList.add('show');
      btnToggle.classList.add('opened');

      // Adds timeout to avoid triggering automatic close event added to body
      setTimeout(() => {
        self._isOpen = true; // Update the state after showing
      });
    }
  },


  /**
   * Clicking outside the sidebar will close it
   */
  handleOutsideClick(e) {
    if ( this._isOpen ) {
      if ( e.target.closest(this._selectors.mobDropdown) === null ) {
        this.close();
      }
    }
  },

  /**
   * If not in dropdown breakpoint, close it
   */
  handleDropdownVisibility() {
    if ( ! this._isOpen ) {
      return;
    }

    if ( !isBreakpoint('tablet') && !isBreakpoint('mobile') ) {
      this.close();
    }
  },

  /**
   * If clicked item has children, show them.
   */
  handleMenuItemClick(index) {
    const dropdownMenu = document.querySelector(this._selectors.mobDropdownMenu);
    const menuItems = dropdownMenu.querySelectorAll(this._selectors.menuItem);
  
    // Toggle the class on the clicked menu item
    menuItems[index].classList.toggle('show-submenu'); // Replace 'active' with the desired class name
  },
  
  // Create a separate function to add the show-submenu class to menu items with data-depth of 1
  showSubmenuOnFurtherChildMenu() {
    const dropdownMenu = document.querySelector(this._selectors.mobDropdownMenu);
    const menuItems = dropdownMenu.querySelectorAll(this._selectors.menuItem);
  
    // Add the show-submenu class to menu items with data-depth of 1
    menuItems.forEach((menuItem) => {
      if (menuItem.dataset.depth >= '1') {
        menuItem.classList.add('show-submenu');
      }
    });
  },

  /**
   * Scrolls back to the top of menu
   */
  resetScrollPosition() {
    document.querySelector(this._selectors.sidebarMenuContainer).scrollTop = 0;
  },

  resetMenuNavigation() {
    // Hides all submenus
    document
      .querySelector(this._selectors.sidebar)
      .querySelectorAll('.show-submenu')
      .forEach(node => {
        node.classList.remove('show-submenu');
      })
    ;

    this._depth = 0;

    // Resets translateX position after sidebar animation finishes
    const dropdownEl = document.querySelector(this._selectors.sidebar);
    waitForElementTransition(dropdownEl)
      .then(() => {
        document.querySelector(this._selectors.sidebarMenu).style.transform = `translateX(0)`;
      })
    ;
  },
};

export default DropdownMenu;
